import { createContext } from "react";

export const BranchSettingContext = createContext(null);
